export default {
      id: "ic_interactive_game-usage",
      viewBox: "0 0 25 24",
      url: "/" + "images/icons.3.109.2.svg#ic_interactive_game-usage",
      toString: function () {
        return this.url;
      }
    }